export default class EventAttendees {
    public userId: number;
    public firstName: string;
    public familyName: string;
    public phoneNumber: string;
    public answer: number;

    constructor(
        id: number,
        firstName: string,
        familyName: string,
        phoneNumber: string,
        answer: number,
    ) {
        this.userId      = id;
        this.firstName   = firstName;
        this.familyName  = familyName;
        this.phoneNumber = phoneNumber;
        this.answer      = answer;
    }
}
